module.exports = __webpack_public_path__ + "img/bg5.706da36e.png";